/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import { setSeccionedLines } from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import SECTIONS from 'constants/sections';

// Styles
import useStyles from './seccionedLinesFilter.styles';

const SeccionedLinesFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedSeccionedLine = useSelector(
    (state: ApplicationState) => state.reports.selectedSeccionedLine,
  );

  const handleStatus = (status: number) => {
    dispatch(
      setSeccionedLines({
        selectedSeccionedLine: status,
      }),
    );
  };

  return (
    <List dense>
      {Object.values(SECTIONS.STATUS).map((item) => (
        <ListItem key={item.LABEL} button>
          <ListItemText
            id={item.LABEL}
            primary={item.LABEL}
            onClick={() => handleStatus(item.VALUE)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              name={item.LABEL}
              color='primary'
              onClick={() => handleStatus(item.VALUE)}
              checked={selectedSeccionedLine === item.VALUE}
              inputProps={{ 'aria-labelledby': item.LABEL }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { SeccionedLinesFilter };
export default SeccionedLinesFilter;
